import { Injectable } from '@angular/core';
import { ProductType, ProductStepsUrl } from '@tmhcc-ng-lib/models';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  result;
  constructor() {}

  getProductName(userData: string, PolicyTypeId?: number) {
    const getProductType = JSON.parse(sessionStorage.getItem(userData));
    this.result = getProductType.PortalAccess.find(
      item =>
        item.PolicyTypeId === PolicyTypeId ||
        item.OtherPolicyTypeIds.findIndex(item => item == PolicyTypeId) >= 0
    );
    return this.result.Name;
  }

  getProductNavUrl() {
    let url;
    switch (sessionStorage.productName) {
      case ProductType.General:
        url = ProductStepsUrl.General;
        break;
      case ProductType.Pollution:
        url = ProductStepsUrl.Pollution;
        break;
      case ProductType.Professional:
        url = ProductStepsUrl.Professional;
        break;
      case ProductType.Builders:
        url = ProductStepsUrl.Builders;
        break;
      case ProductType.Excess:
        url = ProductStepsUrl.Excess;
        break;
      case ProductType.Contractors:
        url = ProductStepsUrl.Contractors;
        break;
      default:
        url = ProductStepsUrl.General;
    }
    return url;
  }
}
